const $header = document.querySelector('[data-role=header]');
const $chooseType = document.querySelector('[data-role=choose-types]') as HTMLElement;
const $careProgram = document.querySelector('[data-role=care-program]') as HTMLElement;
const $categorySections = document.querySelectorAll<HTMLElement>('[data-category]');
const $typesSelect = document.querySelectorAll('[data-type-code]');

const headerHeight = $header?.clientHeight || 0;
const chooseTypeHeight = $chooseType?.clientHeight || 0;
const chooseTypeOffset = $chooseType?.offsetTop - headerHeight || 0;

export const fixCategoryTypes = () => {	
	window.addEventListener('scroll', function() {		
		if (window.scrollY >= chooseTypeOffset && window.scrollY <= $careProgram?.offsetTop - headerHeight - chooseTypeHeight) {		
			$chooseType?.classList.add('fixed');
		} else {
			$chooseType?.classList.remove('fixed');
		}
	
		if (window.innerWidth >= 768) {
			$chooseType?.classList.contains('fixed') ? updateActiveMenuItem() : $typesSelect[0].classList.add('_active');
		}
	});
	
	function  getCurrentSection() {
		const menuRect = $chooseType?.getBoundingClientRect();
		const menuTop = menuRect?.top || 0;
		const menuHeight = menuRect?.height || 0;
		const menuMiddle = menuTop + menuHeight;
		
		let currentSection: string | null = null;
		
		$categorySections.forEach(section => {
			const sectionRect = section.getBoundingClientRect();
			const category = section.dataset.category;
		  
			if (menuMiddle >= sectionRect.top && menuMiddle <= sectionRect.bottom && category) {
				currentSection = category;
			}
		});
		
		return currentSection;
	}
	
	function updateActiveMenuItem() {
		const currentSection = getCurrentSection();
	
		$typesSelect.forEach(($el) => {
			$el.classList.remove('_active');
	
			if (currentSection && $el.getAttribute('data-type-code') === currentSection) {
				$el.classList.add('_active');
			}
		});
	};
};
